export default {
    rotatable: true
}
